/**
 * Скелетоны списков/форм конструктора шаблонов карточек (ОИ, РД и будущие модули).
 */

import { Skeleton } from "@/components/ui/skeleton";

export function CardTemplateTableListSkeleton({
  rows = 4,
  className,
}: {
  rows?: number;
  className?: string;
}) {
  return (
    <div className={className ?? "space-y-2"}>
      {Array.from({ length: rows }, (_, i) => (
        <Skeleton key={i} className="h-10 w-full" />
      ))}
    </div>
  );
}

/** Поля формы в боковой панели конструктора (загрузка черновика). */
export function CardTemplateFormFieldsSkeleton() {
  return (
    <div className="flex flex-1 flex-col space-y-3 px-6 py-4">
      <Skeleton className="h-8 w-full" />
      <Skeleton className="h-8 w-full" />
      <Skeleton className="h-8 w-3/4" />
    </div>
  );
}

/** Тело детального Sheet РД при подгрузке шаблона. */
export function RdCardTemplateDetailBodySkeleton() {
  return <Skeleton className="h-48 mt-4" />;
}
